"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeKpiWidgetMeasureHandler = void 0;
var tslib_1 = require("tslib");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var effects_1 = require("redux-saga/effects");
var widgetValidations_1 = require("./validation/widgetValidations");
var layout_1 = require("../../store/layout");
var kpi_1 = require("../../events/kpi");
var catalogSelectors_1 = require("../../store/catalog/catalogSelectors");
var general_1 = require("../../events/general");
var sdk_model_1 = require("@gooddata/sdk-model");
var redux_batched_actions_1 = require("redux-batched-actions");
var widgetTypes_1 = require("../../types/widgetTypes");
var queries_1 = require("../../queries");
var queryCall_1 = require("../../store/_infra/queryCall");
var objRefMap_1 = require("../../../_staging/metadata/objRefMap");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
function validateMeasure(ctx, cmd) {
    var measureRef, measures, measure;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                measureRef = cmd.payload.measureRef;
                return [4 /*yield*/, effects_1.select(catalogSelectors_1.selectAllCatalogMeasuresMap)];
            case 1:
                measures = _a.sent();
                measure = measures.get(measureRef);
                if (!measure) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Attempting to use non-existent measure for KPI widget. " + sdk_model_1.objRefToString(measureRef) + " does not exist.");
                }
                return [2 /*return*/, measure];
        }
    });
}
function determineHeaderToUse(cmd, measure) {
    var header = cmd.payload.header;
    if (typeof header === "string" && header === "from-measure") {
        return {
            title: measure.measure.title,
        };
    }
    else if (widgetTypes_1.isWidgetHeader(header)) {
        return header;
    }
    return undefined;
}
function determineDateDatasetToUse(widget, measure) {
    var measureDateDatasets, catalogDataSet;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!widget.dateDataSet) {
                    return [2 /*return*/, undefined];
                }
                return [4 /*yield*/, effects_1.call(queryCall_1.query, queries_1.queryDateDatasetsForMeasure(measure.measure.ref))];
            case 1:
                measureDateDatasets = _a.sent();
                catalogDataSet = objRefMap_1.newCatalogDateDatasetMap(measureDateDatasets.dateDatasets).get(widget.dateDataSet);
                if (!catalogDataSet) {
                    if (!isEmpty_1.default(measureDateDatasets.dateDatasetsOrdered)) {
                        return [2 /*return*/, measureDateDatasets.dateDatasetsOrdered[0]];
                    }
                    return [2 /*return*/, undefined];
                }
                return [2 /*return*/, catalogDataSet];
        }
    });
}
/**
 * When switching measure used by the KPI the handler needs to deal with several things:
 *
 * -  Input validation; both KPI widget and the new measure must be valid
 * -  Determining what header to use for the KPI. The header may come either as part of the command or command may
 *    indicate to automatically use title from measure OR the command may not provide any header in which case the
 *    old header will be retained
 * -  Determining what date dataset to use for filtering. Different measures can use different date datasets for
 *    filtering - the existing dateDataSet setting on the KPI widget may not be valid in the context of the
 *    new measure.
 *
 *    Thus the command triggers logic (in generator) to query available date datasets for the metric, check if the
 *    existing dateDataSet is among the results of the query. If so, the existing date dataset will be kept. Otherwise
 *    code will pick the most-relevant date dataset.
 *
 *    If the KPI is not setup with date dataset, then nothing happens.
 *
 *
 */
function changeKpiWidgetMeasureHandler(ctx, cmd) {
    var correlationId, widgets, kpiWidget, measure, header, dateDataset, actions, updatedWidgets, updatedKpiWidget;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                correlationId = cmd.correlationId;
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectWidgetsMap)];
            case 1:
                widgets = _a.sent();
                kpiWidget = widgetValidations_1.validateExistingKpiWidget(widgets, cmd, ctx);
                return [4 /*yield*/, effects_1.call(validateMeasure, ctx, cmd)];
            case 2:
                measure = _a.sent();
                header = determineHeaderToUse(cmd, measure);
                return [4 /*yield*/, effects_1.call(determineDateDatasetToUse, kpiWidget, measure)];
            case 3:
                dateDataset = _a.sent();
                actions = [
                    layout_1.layoutActions.replaceKpiWidgetMeasure({
                        ref: kpiWidget.ref,
                        measureRef: measure.measure.ref,
                        undo: {
                            cmd: cmd,
                        },
                    }),
                    layout_1.layoutActions.replaceWidgetDateDataset({
                        ref: kpiWidget.ref,
                        dateDataSet: dateDataset === null || dateDataset === void 0 ? void 0 : dateDataset.dataSet.ref,
                        undo: {
                            cmd: cmd,
                        },
                    }),
                ];
                if (header) {
                    actions.push(layout_1.layoutActions.replaceWidgetHeader({
                        ref: kpiWidget.ref,
                        header: header,
                        undo: {
                            cmd: cmd,
                        },
                    }));
                }
                return [4 /*yield*/, effects_1.put(redux_batched_actions_1.batchActions(actions, "@@CMD.UPDATE.KPI"))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectWidgetsMap)];
            case 5:
                updatedWidgets = _a.sent();
                updatedKpiWidget = updatedWidgets.get(kpiWidget.ref);
                return [2 /*return*/, kpi_1.kpiWidgetMeasureChanged(ctx, kpiWidget.ref, updatedKpiWidget, measure.measure, header, correlationId)];
        }
    });
}
exports.changeKpiWidgetMeasureHandler = changeKpiWidgetMeasureHandler;
//# sourceMappingURL=changeKpiWidgetMeasureHandler.js.map